export default interface IErrorsResponse {
  type?: string;
  title?: string;
  errors?: IError[];
}

export class ErrorsResponse extends Error implements IErrorsResponse{
  type?: string;
  title?: string;
  errors?: IError[];
  constructor(message: string, type?: string, errors?: IError[], title?: string) {
    super(message);
    this.name = "ErrorsResponse";
    this.type = type;
    this.errors = errors;
    this.title = title;
  }
}

export interface IError{
  type?: string;
  message?: string;
  code?: string;
  paramName?: string;
}
